import React from 'react'
import Header from './Header'
import Footer from './Footer'

function Jobs() {

    const jobOpenings = [
        {
          title: "Frontend Developer",
          location: "Remote / Dhaka",
          type: "Full-Time",
          description: "We’re looking for a skilled React developer to build modern web apps."
        },
        {
          title: "Digital Marketing Specialist",
          location: "Remote",
          type: "Part-Time",
          description: "Experienced in SEO, Google Ads, and content strategy."
        },
        {
          title: "Customer Support Executive",
          location: "On-site – Dhaka",
          type: "Full-Time",
          description: "Manage customer queries via phone, chat, and email in a professional manner."
        },
      ];
    
      const careerFeatures = [
        "Flexible Work Environment",
        "Growth Opportunities",
        "Team Collaboration & Culture",
        "Work-Life Balance",
        "Skill Development & Training",
        "Competitive Compensation",
      ];
  return (
    <>
    <Header />
   
    <div className='about_section layout_padding'>
    <div className="container mt-5 mb-5">
      {/* Header */}
      <div className="text-center mb-5">
        <h2 className="font-weight-bold">Join Our Team</h2>
        <p>Explore exciting career opportunities and grow with us!</p>
      </div>

      {/* Job Openings Section */}
      <div className="mb-5">
        <h4 className="mb-4">🔥 Current Job Openings</h4>
        <div className="row">
        <h2 style={{color:"red"}}>Unfortunately we don't have any open position right now !!</h2>
        </div>
      </div>

      {/* Career Features Section */}
      <div className="bg-light p-5 rounded">
        <h4 className="mb-4">✨ Why Choose a Career With Us?</h4>
        <div className="row">
          {careerFeatures.map((feature, idx) => (
            <div className="col-md-6 mb-3" key={idx}>
              <div className="d-flex align-items-start">
                <i className="fa fa-check text-success mr-2 mt-1"></i>
                <p className="mb-0">{feature}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    </div>

    <Footer />
    </>
  )
}

export default Jobs